import { z } from "zod";
//#region src/payment/extraPackageSku.ts
const PackageContentKind = {
	Kaisuuken: "kaisuuken",
	Decoration: "decoration"
};
const packageContentMetadataSchema = z.object({
	hideInCard: z.boolean().optional(),
	displayNameI18nKey: z.string().min(1).optional(),
	displayName: z.string().min(1).optional(),
	label: z.string().min(1).optional(),
	name: z.string().min(1).optional()
}).strict();
const extraPackageContentSchema = z.object({
	kind: z.enum([PackageContentKind.Kaisuuken, PackageContentKind.Decoration]),
	code: z.string().min(1).optional(),
	quantity: z.number().int().nonnegative(),
	metadata: packageContentMetadataSchema.optional()
}).strict();
const packageCardMarketingMetadataSchema = z.object({
	packNameI18nKey: z.string().min(1).optional(),
	packName: z.string().min(1).optional(),
	valueRatioPercent: z.number().positive().optional(),
	totalValueTextI18nKey: z.string().min(1).optional(),
	totalValueText: z.string().min(1).optional(),
	equivalentImages: z.int().positive().optional(),
	equivalentImagesTextI18nKey: z.string().min(1).optional(),
	equivalentImagesText: z.string().min(1).optional()
}).strict();
const packageMarketingMetadataSchema = packageCardMarketingMetadataSchema.extend({ card: packageCardMarketingMetadataSchema.optional() }).strict();
/**
* Per-tier source values stored in `ExtraPackageSku.tierValues` (JSONB).
*
* Mirrors the YAML `values[]` shape: `tier` (0-3), `value` (credits at this tier), and
* optional `tierPercentage` (per-tier bonus annotation, present on some packages only —
* e.g. extra-package-3 / extra-package-5; missing on extra-package-1 / -2).
*
* Computed runtime fields (`creditsAfterBoosts`, the active boost list) are NOT persisted —
* they're derived at fulfillment time from these source values + the live boost catalog, so
* persisting them would silently desync from the boost configuration.
*/
const extraPackageSkuTierValueSchema = z.object({
	tier: z.int().min(0).max(3),
	value: z.int().nonnegative(),
	tierPercentage: z.int().nonnegative().optional()
}).strict();
const extraPackageSkuTierValuesSchema = z.array(extraPackageSkuTierValueSchema).min(1);
/**
* Package contents stored in `ExtraPackageSku.packageContents` (JSONB).
* The element-level schema (`extraPackageContentSchema`) is strict and the array form is
* what admin oRPC + the YAML migration script both validate against.
*/
const extraPackageSkuPackageContentsSchema = z.array(extraPackageContentSchema);
/**
* Marketing metadata stored in `ExtraPackageSku.marketingMetadata` (JSONB).
* Strict-typed at the top level and on the nested `card` object — admin UI inputs must
* conform to the documented key set rather than a free-form record.
*/
const extraPackageSkuMarketingMetadataSchema = packageMarketingMetadataSchema;
const extraPackageGroupSchema = z.object({
	id: z.uuid(),
	key: z.string().min(1),
	name: z.string().min(1),
	sortOrder: z.int(),
	activeSince: z.iso.datetime().nullable(),
	deactivatedAt: z.iso.datetime().nullable(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
	lastOperatorId: z.coerce.bigint().nullable()
});
//#endregion
export { PackageContentKind, extraPackageContentSchema, extraPackageGroupSchema, extraPackageSkuMarketingMetadataSchema, extraPackageSkuPackageContentsSchema, extraPackageSkuTierValueSchema, extraPackageSkuTierValuesSchema, packageCardMarketingMetadataSchema, packageContentMetadataSchema, packageMarketingMetadataSchema };
